import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { TabSwitchContext } from './TabSwitch.Context.es.js';

/**
 * Create TabSwitch Provider.
 *
 */ const TabSwitchProvider = ({ selected, onChange, children })=>{
    const [tab, setCurrentTab] = useState(selected);
    const setTab = useCallback((currentTab)=>{
        setCurrentTab(currentTab);
        onChange?.(currentTab);
    }, [
        onChange
    ]);
    return jsx(TabSwitchContext.Provider, {
        value: {
            tab,
            setTab
        },
        children: children
    });
};
TabSwitchProvider.displayName = 'TabSwitch.Provider';

export { TabSwitchProvider };
//# sourceMappingURL=TabSwitch.Provider.es.js.map
